/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FileMusic = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4" }],
    ["path", { d: "M8 18v-7.7L16 9v7" }],
    ["circle", { cx: "14", cy: "16", r: "2" }],
    ["circle", { cx: "6", cy: "18", r: "2" }]
  ]
];

export { FileMusic as default };
//# sourceMappingURL=file-music.js.map
